import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BoondockFacade } from '@curbnturf/boondock-listing';
import { Boondock } from '@curbnturf/objects';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'curbnturf-rating-boondock-complete',
  templateUrl: './rating-boondock-complete.component.html',
  styleUrls: ['./rating-boondock-complete.component.scss'],
  standalone: true,
  imports: [AsyncPipe, IonicModule, NgIf],
})
export class RatingBoondockCompleteComponent implements OnInit, OnDestroy {
  @Output() navigateBack: EventEmitter<void> = new EventEmitter<void>();

  @Output() complete: EventEmitter<void> = new EventEmitter<void>();

  subscriptions: Subscription[] = [];

  boondock$: Observable<Boondock | null>;

  appContext: boolean;

  constructor(
    private route: ActivatedRoute,
    private modalController: ModalController,
    private navCtrl: NavController,
    private boondockFacade: BoondockFacade,
  ) {}

  ngOnInit(): void {
    this.boondock$ = this.boondockFacade.selected$;
    this.subscriptions.push(
      this.route.data.subscribe((data) => {
        this.appContext = data.appContext || false;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  async onComplete() {
    // Emit event for web and navigate for app.
    if (this.appContext) {
      await this.navCtrl.navigateForward(['/']);
    } else {
      this.complete.emit();
    }
    this.modalController?.dismiss();
  }
}
